module.exports = __webpack_public_path__ + "static/media/DIAMOND-8.9bb03816.svg";